// extracted by mini-css-extract-plugin
module.exports = {"loader":"index_loader__21qM8","load8":"index_load8__2D82z"};